import { useState, useEffect } from 'react';

/* eslint-disable no-undef */
const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return [width];
};
/* eslint-enable no-undef */

export default useWindowWidth;
